/* eslint-disable no-underscore-dangle,no-undef */
if (__CLIENT__) {
  window.__nbcnd__ = window.__nbcnd__ || {};
  window.__nbcnd__.adQueue = window.__nbcnd__.adQueue || [];
}

/**
 * @typedef {object} MpsAd
 * @property {(handler: () => void) => void} onRender
 */

/**
 * @typedef {(container: HTMLDivElement) => MpsAd} CreateAdFunction
 */

/**
 * @typedef {(mps: unknown, createAd: CreateAdFunction) => void} AdReadyCallback
 */

/**
 * @typedef {function(AdReadyCallback): void} AdReadyFunction
 */

/**
 * Function to queue a callback to be executed when ads are ready.
 * @param {(mps: unknown, createAd: CreateAdFunction) => void} fn - The callback function to be queued.
 */
export function adReady(fn) {
  if (__CLIENT__) {
    window.__nbcnd__.adQueue.push(fn);
  }
}
/* eslint-enable no-underscore-dangle,no-undef */
